import { useState, useEffect } from'react';

export function useMediaQuery(query) {
 const [matches, setMatches] = useState(() => {
 if (typeof window ==='undefined') return false;
 return window.matchMedia(query).matches;
 });

 useEffect(() => {
 if (typeof window ==='undefined') return;
 const mediaQuery = window.matchMedia(query);
 setMatches(mediaQuery.matches);

 const handler = (e) => setMatches(e.matches);
 mediaQuery.addEventListener('change', handler);
 return () => mediaQuery.removeEventListener('change', handler);
 }, [query]);

 return matches;
}

export function useIsMobile() { return useMediaQuery('(max-width: 768px)'); }
export function useIsTablet() { return useMediaQuery('(max-width: 1024px)'); }
export function useIsDesktop() { return useMediaQuery('(min-width: 1024px)'); }